<template>
  <div class="WarrantyExtenish">
    <div class="form-title">
      <span class="icon"></span>
      <span>{{ $i18n.t('yanbaoBuy') }}</span>
    </div>
    <div class="form-main">
      <div class="product-list" v-for="(m, index) in productList" :key="index">
        <div class="product-title">
          {{ $i18n.t('extension1') }}-{{ index + 1 }}
        </div>
        <div class="product-input">
          <el-input
            v-model="m.value"
            :placeholder="$i18n.t('extension2')"
          ></el-input>
          <!-- <i class="el-icon-warning-outline"></i> -->
          <span class="product-btn" @click="checked(m)">{{ $i18n.t('check') }}</span>
        </div>
        <div class="product-title" v-if="m.priceList.length > 0">{{ $i18n.t('extension4') }}</div>
        <div class="product-btns" v-if="m.priceList.length > 0">
          <span
            class="product-btn"
            v-for="p in m.priceList"
            :key="p.year"
            :class="{ active: m.num === p.year }"
            @click="changePrice(m, p)"
            >{{ p.year }} years</span
          >
        </div>
        <div class="product-title" v-if="m.price > 0">
          Price: <span class="price-color">{{ m.priceUnit }} {{ m.price }}</span>
        </div>
        <div class="product-add">
          <span
            class="product-btn add"
            @click="productList.push({ checkFlag: false, num: 0, value: '', price: 0, priceList: [] });checkFlagFn();"
            v-if="index === productList.length - 1 &&  productList.length < 5"
          >
            <i class="el-icon-circle-plus"></i>
            {{ $i18n.t('extension3') }}
          </span>
          <span
            class="product-btn"
            v-if="index > 0"
            @click="productList.splice(index, 1)"
            >{{ $i18n.t('delete') }}</span
          >
        </div>
        <!-- <div class="product-title" v-if="index === productList.length - 1">
          Total Price:
          <span class="price-color">￥{{ totalPrice }}</span>
        </div> -->
      </div>
      <div class="submit">
        <el-button @click="buySubmit" :disabled="!checkFlag">{{ $i18n.t('extension5') }}</el-button>
      </div>
      <p>{{ $i18n.t('extension6') }}</p>
      <p class="mt20">
        {{ $i18n.t('extension7') }}
      </p>
      <p>
        {{ $i18n.t('extension8') }}
      </p>
      <p>
        {{ $i18n.t('extension9') }}
      </p>
      <p>{{ $i18n.t('extension10') }}</p>
    </div>

    <el-dialog
        title="Activation succeeded"
        :visible.sync="dialogVisible"
        width="50%">
        <span>{{ $i18n.t('info2') }}, {{ $i18n.t('info7') }} <a style="color: #108ee9;" href="javascript:;" @click="$router.push({ name: 'Ordermanagement' })"> {{ $i18n.t('orderManagementMenu') }} </a>,
          {{ $i18n.t('info8') }} <a style="color: #108ee9;" href="javascript:;" @click="window.open(quoteUrl)">{{ $i18n.t('download') }}</a>. {{ $i18n.t('info3') }} </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" @click="dialogVisible = false">OK</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { trim } from "lodash";
import { checkedskuNoApi, buyApi, getPriceApi } from "../../../deps/api";
export default {
  mounted() {},
  computed: {
    totalPrice() {
      let num = 0;
      this.productList.forEach((i) => (num += i.price));
      return num;
    },
  },
  methods: {
    changePrice(data, p) {
      data.checkFlag = true;
      data.num = p.year;
      data.price = p.price
      data.priceUnit = p.priceUnit;
      this.checkFlagFn();
    },
    checkFlagFn() {
      this.checkFlag = true;
      this.productList.forEach((v) => {
        if (!v.checkFlag) { this.checkFlag = false }
      })
    },
    checked(data) {
      if (!window.isLogin) {
        this.$openWaring();
        return;
      }
      if (!trim(data.value)) {
        this.$message.warning(this.$i18n.t('search13'));
        return;
      }
      checkedskuNoApi(data.value).then((res) => {
        const priceData = {
          skuno: data.value,
          year: data.num,
        };
        getPriceApi(priceData).then((res) => {
          this.$message.success(this.$i18n.t('success'));
          data.priceList = res.data;
          data.price = 0;
          data.num = 0;
        });
      });
    },
    buySubmit() {
      if (!window.isLogin) {
        this.$openWaring();
        return;
      }
      this.quoteUrl = '';
      if (this.productList.some((i) => !trim(i.value))) {
        this.$message.warning(this.$i18n.t('numberEmpty'));
        return;
      }
      const data = this.productList.map((i) => {
        return {
          activeYear: i.num,
          skuNo: i.value
        };
      });
      buyApi(data).then((res) => {
        this.quoteUrl = res.data.quoteUrl;
        this.dialogVisible = true;
        this.productList = [
          {
            value: "",
            num: "",
            price: 0,
            priceList: []
          },
        ]
        this.checkFlagFn();
      });
    },
  },
  data() {
    return {
      searchValue: "",
      dialogVisible: false,
      quoteUrl: "",
      productList: [
        {
          value: "",
          num: "",
          price: 0,
          priceList: []
        },
      ],
      checkFlag: false
    };
  },
};
</script>

<style lang="stylus">
.WarrantyExtenish {
  padding-left: 50px;
  padding-bottom: 130px;

  .form-title {
    .icon {
      width: 10px;
      height: 10px;
      background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
      border-radius: 2px;
      display: inline-block;
      transform: rotate(45deg);
      margin-right: 4px;
    }

    span {
      font-size: 18px;
      color: #3E3E3E;
    }

    .f12 {
      font-size: 14px;
      color: #717171;
    }
  }

  .form-main {
    text-align: center;

    p {
      font-size: 14px;
      color: #A2A0A5;
      text-align: left;

      &.mt20 {
        margin-top: 20px;
      }

      a {
        color: #108ee9;
      }
    }

    .product-list {
      text-align: left;
      margin-bottom: 90px;

      .product-title {
        color: #717171;
        font-size: 16px;
        margin: 16px 0;

        .price-color {
          color: #ff5b5b;
          font-size: 24px;
          padding-left: 5px;
        }
      }

      .product-input {
        position: relative;

        i {
          position: absolute;
          left: 360px;
          font-size: 22px;
          top: 10px;
        }
      }

      .product-btn {
        display: inline-block;
        line-height: 40px;
        cursor: pointer;
        border: 1px solid #D2D2D2;
        height: 40px;
        border-radius: 24px;
        min-width: 89px;
        text-align: center;

        &:hover {
          background: #D2D2D2;
        }
      }

      .product-btns {
        .product-btn {
          margin-right: 30px;

          &.active {
            border-color: #FF254F;
            color: #FF254F;
          }

          &:hover {
            background: #E1E1E1;
            border-color: #FF254F;
            color: #FF254F;
          }
        }
      }

      .product-add {
        margin-top: 30px;

        .product-btn.add {
          width: 510px;
          margin-right: 30px;
        }
      }

      .el-input {
        width: 400px;
        margin-right: 30px;
      }

      .el-input__inner {
        border-radius: 24px;
        border: 1px solid #D2D2D2;
        color: #717171;
        padding-right: 40px;
      }
    }

    .submit {
      text-align: left;
      margin-top: 60px;
      overflow: hidden;

      img {
        float: left;
        margin-right: 55px;
      }

      .el-button {
        width: 280px;
        height: 48px;
        background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
        border-radius: 34px;
        padding: 0;
        color: #fff;
        font-size: 24px;
        border: 0;
        margin-top: 60px;
        margin-bottom: 30px;
        float: left;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/homePages/routes/WarrantyExtenish.vue